import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import JourneyPath from './shared/JourneyPath';

interface PracticeStartScreenProps {
  title: string;
  onStart: () => void;
  currentTrack?: string | null;
}

const PracticeStartScreen: React.FC<PracticeStartScreenProps> = ({ title, onStart, currentTrack }) => {

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-blue-100 flex flex-col justify-center p-6">
      {/* Journey Path - positioned at top of screen */}
      <div className="absolute top-6 left-0 right-0">
        <JourneyPath currentTrack={currentTrack ?? undefined} />
      </div>

      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-5xl lg:text-6xl font-bold text-center mb-12">
          <span className="bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
            {title}
          </span>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center relative"
        >
          {/* Pointing Finger */}
          <motion.div
            animate={{
              x: [0, 10, 0],
              scale: [1, 1.1, 1],
              rotate: -15
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="absolute -left-32 top-1/2 transform -translate-y-1/2 text-8xl hidden md:block"
          >
            👉
          </motion.div>

          <motion.button
            whileHover={{ scale: 1.08, rotate: 1 }}
            whileTap={{ scale: 0.92 }}
            animate={{
              scale: [1, 1.1, 1],
              y: [0, -8, 0]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            onClick={onStart}
            className="h-20 lg:h-24 px-16 rounded-3xl font-bold text-2xl lg:text-3xl shadow-xl transition-all duration-300 bg-gradient-to-br from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 text-white border-4 border-blue-700 cursor-pointer hover:shadow-2xl transform-gpu flex items-center justify-center gap-4 mx-auto"
          >
            <Play className="w-12 h-12" />
            <span>START PRACTICE</span>
          </motion.button>

          {/* Pointing finger for smaller screens */}
          <motion.div
            animate={{
              y: [0, -5, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="mt-8 text-6xl md:hidden"
          >
            👆
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default PracticeStartScreen;